import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import adminNotificationService from "../../../services/adminNotificationService";
import { Bell, Check, ChevronRight } from "lucide-react";
import { useAuth } from "../../../context/authContext";
const DropdownNotification = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [unread, setUnread] = useState(false);
  const [unreadNotifications, setUnreadNotifications] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const { user } = useAuth();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    const res = await adminNotificationService.getAdminNotifications();
    setNotifications(res);
    const unread = res.filter(
      (notification) => !notification.readBy.includes(user._id)
    );

    setUnreadNotifications(unread);
    setUnread(unread.length > 0);
  };

  const markAsRead = async (notificationId) => {
    await adminNotificationService.markOneAsRead(notificationId);
    fetchNotifications();
  };

  const markAllAsRead = async () => {
    await adminNotificationService.markAllAsRead();
    fetchNotifications();
  };

  const getNotificationTime = (createdAt) => {
    const date = new Date(createdAt);
    const now = new Date();
    const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));

    if (diffInHours < 1) return "Gerade eben";
    if (diffInHours < 24) return `Vor ${diffInHours} Stunden`;
    return date.toLocaleDateString("de-DE");
  };

  return (
    <div ref={dropdownRef} className="relative">
      <div
        className="relative flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-stroke bg-gray-200 hover:bg-gray-300 dark:border-strokedark dark:bg-meta-4"
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <span
          className={`absolute -top-1 -right-1 h-3 w-3 rounded-full bg-red-500 ${
            dropdownOpen || !unread ? "hidden" : "block"
          }`}
        ></span>
        <Bell className="h-5 w-5 text-gray-600 dark:text-white" />
      </div>

      {dropdownOpen && (
        <div className="absolute right-0 mt-2 w-80 rounded-lg border border-stroke bg-white shadow-lg dark:border-strokedark dark:bg-boxdark">
          <div className="border-b border-stroke px-4 py-3 dark:border-strokedark">
            <div className="flex items-center justify-between">
              <h5 className="text-sm font-medium">Benachrichtigungen</h5>
              {unreadNotifications.length > 0 && (
                <button
                  onClick={markAllAsRead}
                  className="text-xs text-blue-500 hover:text-blue-600"
                >
                  Alle als gelesen markieren
                </button>
              )}
            </div>
          </div>

          <div className="max-h-96 overflow-y-auto">
            {unreadNotifications.length > 0 ? (
              <>
                <div className="bg-gray-50 px-4 py-2 dark:bg-gray-700">
                  <h6 className="text-xs font-medium text-gray-500 dark:text-gray-400">
                    Ungelesen ({unreadNotifications.length})
                  </h6>
                </div>
                {unreadNotifications.map((notification) => (
                  <div
                    key={notification._id}
                    className="border-b border-stroke px-4 py-3 hover:bg-gray-50 dark:border-strokedark dark:hover:bg-meta-4"
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex-1">
                        <p className="text-sm text-gray-600 dark:text-white">
                          {notification.message}
                        </p>
                        <span className="text-xs text-gray-400">
                          {getNotificationTime(notification.createdAt)}
                        </span>
                      </div>
                      <button
                        onClick={() => markAsRead(notification._id)}
                        className="ml-3 rounded-full p-1 hover:bg-gray-200 dark:hover:bg-gray-600"
                      >
                        <Check className="h-4 w-4 text-gray-400" />
                      </button>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="px-4 py-3">
                <p className="text-sm text-gray-500">
                  Keine ungelesenen Nachrichten
                </p>
              </div>
            )}

            {notifications.length > unreadNotifications.length && (
              <div className="border-t border-stroke px-4 py-3 dark:border-strokedark">
                <button
                  className="flex w-full items-center justify-between text-sm text-gray-500 hover:text-gray-700"
                  onClick={() => {
                    navigate("/admindashboard/adminnotifications");
                  }}
                >
                  <span>Alle Benachrichtigungen anzeigen</span>
                  <ChevronRight className="h-4 w-4" />
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownNotification;
